

export const getCurrencyFormats = code => ({
    number: {
        currency: {
            style: 'currency',
            currency: code
        },
        currencyInteger: {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    }
});
